import React, {ReactElement} from 'react'
import {IconDisplay} from '../../genericComponents/IconDisplay'
import {ClassificationType} from './ClassificationType'

export enum ItemLabelEnum {
    COMPANY = 'Company Item',
    MANUFACTURER = 'Manufacturer Item',
    ABSTRACT = 'Abstract Item',
    SINGLESOURCE = 'Company - Single Source Item',
    MULTISOURCE = 'Company - Multi Source Item'
}

export enum ItemTypeEnum {
    COMPANY = 'Company Item',
    MANUFACTURER = 'Manufacturer Item',
    ABSTRACT = 'Abstract Item',
    SINGLESOURCE = 'Single Source Item',
    MULTISOURCE = 'Multi Source Item'
}

export const ItemTypeIconSourceMap = new Map<string, {url: string, label: string}>([
    [ItemTypeEnum.COMPANY.toUpperCase(), {url: '/images/item-type/company_item.svg', label: ItemLabelEnum.COMPANY}],
    [ItemTypeEnum.SINGLESOURCE.toUpperCase(), {url: '/images/item-type/single_source.svg', label: ItemLabelEnum.SINGLESOURCE}],
    [ItemTypeEnum.MULTISOURCE.toUpperCase(), {url: '/images/item-type/multi_source.svg', label: ItemLabelEnum.MULTISOURCE}],
    [ItemTypeEnum.MANUFACTURER.toUpperCase(), {url: '/images/item-type/manufacturer_item.svg', label: ItemLabelEnum.MANUFACTURER}],
    [ItemTypeEnum.ABSTRACT.toUpperCase(), {url: '/images/item-type/abstract_item.svg', label: ItemLabelEnum.ABSTRACT}],
    ['default', {url: '/images/item-type/company_item.svg', label: ItemLabelEnum.COMPANY}]
])

export interface ItemType {
    type: string
    label: string
    icon: ReactElement | null
}

export const getItemType = (itemType: ItemType | ClassificationType) => {
    const defaultItemType: ItemType = {
        type: ItemTypeEnum.ABSTRACT,
        label: 'Defined by',
        icon: (
            <IconDisplay
                className="type-item-icon"
                iconName={ItemTypeEnum.ABSTRACT}
                iconSourceMap={ItemTypeIconSourceMap}
                iconLabel={ItemLabelEnum.ABSTRACT}
            />
        )
    }

    const itemTypeMap = new Map<string, ItemType>([
        [
            ItemTypeEnum.COMPANY,
            {
                type: ItemTypeEnum.COMPANY,
                label: 'Defined by',
                icon: (
                    <IconDisplay
                        className="type-item-icon"
                        iconName={ItemTypeEnum.COMPANY}
                        iconSourceMap={ItemTypeIconSourceMap}
                        iconLabel={ItemLabelEnum.COMPANY}
                    />
                )
            }
        ],
        [
            ItemTypeEnum.SINGLESOURCE,
            {
                type: ItemTypeEnum.SINGLESOURCE,
                label: 'Defined by',
                icon: (
                    <IconDisplay
                        className="type-item-icon"
                        iconName={ItemTypeEnum.SINGLESOURCE}
                        iconSourceMap={ItemTypeIconSourceMap}
                        iconLabel={ItemLabelEnum.SINGLESOURCE}
                    />
                )
            }
        ],
        [
            ItemTypeEnum.MULTISOURCE,
            {
                type: ItemTypeEnum.MULTISOURCE,
                label: 'Defined by',
                icon: (
                    <IconDisplay
                        className="type-item-icon"
                        iconName={ItemTypeEnum.MULTISOURCE}
                        iconSourceMap={ItemTypeIconSourceMap}
                        iconLabel={ItemLabelEnum.MULTISOURCE}
                    />
                )
            }
        ],
        [
            ItemTypeEnum.MANUFACTURER,
            {
                type: ItemTypeEnum.MANUFACTURER,
                label: 'Defined by',
                icon: (
                    <IconDisplay
                        className="type-item-icon"
                        iconName={ItemTypeEnum.MANUFACTURER}
                        iconSourceMap={ItemTypeIconSourceMap}
                        iconLabel={ItemLabelEnum.MANUFACTURER}
                    />
                )
            }
        ],
        [
            ItemTypeEnum.ABSTRACT,
            {
                type: ItemTypeEnum.ABSTRACT,
                label: 'Defined by',
                icon: (
                    <IconDisplay
                        className="type-item-icon"
                        iconName={ItemTypeEnum.ABSTRACT}
                        iconSourceMap={ItemTypeIconSourceMap}
                        iconLabel={ItemLabelEnum.ABSTRACT}
                    />
                )
            }
        ]
    ])
    return itemTypeMap.get(itemType?.label) ?? defaultItemType
}
